<script>
export default {
  name: 'FundraiserRaisedAmount',
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  computed: {
    raisedFormatted() {
      return this.$filters.formatCurrency(this.fundraiser.cached?.raised, this.fundraiser.currency)
    },
    goalFormatted() {
      return this.$filters.formatCurrency(this.fundraiser.goal, this.fundraiser.currency)
    },
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between items-end mb-2">
    <h2 class="text-2xl lg:text-3xl font-medium">
      {{ raisedFormatted }}
    </h2>
    <span v-if="fundraiser.settings?.goal_hidden !== true" class="text-sm font-medium mb-[2px]">
      {{ fundraiser.cached.percentage_raised }}% of {{ goalFormatted }} goal
    </span>
  </div>
</template>

<style scoped>

</style>
